const LAST_CLICKED_KEY = 'collectionScrollPosition-lastClickedItemHref'
const LAST_CLICKED_INDEX_KEY = 'collectionScrollPosition-lastClickedItemIndex'
const LAST_VISITED_KEY = 'collectionScrollPosition-lastVisitedCollectionUrl'

class CollectionScrollPosition {
  constructor () {
    this.lastClickedItemHref = sessionStorage.getItem(LAST_CLICKED_KEY)
    this.lastClickedItemIndex = sessionStorage.getItem(LAST_CLICKED_INDEX_KEY)
    this.lastVisitedUrls = sessionStorage.getItem(LAST_VISITED_KEY)
    this.currentUrl = new URL(window.location.href).pathname
    this.init()
  }

  init () {
    if (this.currentUrl.includes('/collections/')) {
      this.handleCollectionTemplate()
    } else if (this.currentUrl.includes('/products/')) {
      this.handleProductTemplate()
    } else if (!this.arrivedViaCapturedClick()) {
      this.clearData()
    }
  }

  // True when we just navigated to the page the last captured click pointed to.
  arrivedViaCapturedClick () {
    if (!this.lastClickedItemHref) return false

    let lastClickedPath
    try {
      lastClickedPath = new URL(
        this.lastClickedItemHref,
        window.location.origin,
      ).pathname
    } catch (e) {
      return false
    }

    return lastClickedPath === this.currentUrl
  }

  // True when this page contains the link the last captured click pointed to.
  currentPageContainsCapturedClickTarget () {
    if (!this.lastClickedItemHref) return false
    return !!document.querySelector(`a[href="${this.lastClickedItemHref}"]`)
  }

  handleCollectionTemplate () {
    this.checkLastVisitedUrls(this.currentUrl)

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }

    this.restoreScrollPosition()
    this.captureClickedItemHref()
  }

  handleProductTemplate () {
    this.checkLastVisitedUrls(this.currentUrl)

    if (!this.lastClickedItemHref) return

    if (!this.arrivedViaCapturedClick()) {
      this.clearData()
    }
  }

  restoreScrollPosition () {
    if (!this.lastClickedItemHref) return

    if (this.arrivedViaCapturedClick()) return

    const matchingElements = document.querySelectorAll(
      `a[href="${this.lastClickedItemHref}"]`,
    )
    const index = Number(this.lastClickedItemIndex)
    const element = matchingElements[index] || matchingElements[0]
    if (!element) return

    element.scrollIntoView({
      behavior: 'instant',
      block: 'center',
      inline: 'center',
    })
  }

  captureClickedItemHref () {
    // Fallback for cards outside load-more-list, which captures its own clicks.
    window.addEventListener('click', e => {
      const isProductCard = e.target.classList.contains('prd-Card_Link')
      const isPromoToProduct =
        e.target.classList.contains('util-FauxLink_Link') &&
        !!e.target.closest('.clc-Promotion')

      if (isProductCard || isPromoToProduct) {
        const href = e.target.getAttribute('href')?.split('?')[0]
        if (href) {
          const matchingElements = document.querySelectorAll(
            `a[href="${href}"]`,
          )
          const index = Array.from(matchingElements).indexOf(e.target)

          sessionStorage.setItem(LAST_CLICKED_KEY, href)
          sessionStorage.setItem(LAST_CLICKED_INDEX_KEY, index.toString())
        }
      }
    })
  }

  checkLastVisitedUrls (url) {
    const array = this.lastVisitedUrls
      ? [...JSON.parse(this.lastVisitedUrls)]
      : []
    array.push(url)

    const currentType = this.getPageType(array[array.length - 1])
    const previousType = this.getPageType(array[array.length - 2])

    if (!previousType) {
      sessionStorage.setItem(LAST_VISITED_KEY, JSON.stringify(array))
      return
    }

    const shouldPreserveData =
      this.arrivedViaCapturedClick() ||
      this.currentPageContainsCapturedClickTarget()

    if (currentType === previousType && !shouldPreserveData) {
      this.clearData()
    } else {
      sessionStorage.setItem(LAST_VISITED_KEY, JSON.stringify(array))
    }
  }

  getPageType (url) {
    if (!url) return null
    if (url.includes('/collections/')) return 'collection'
    if (url.includes('/products/')) return 'product'
    return 'other'
  }

  clearData () {
    sessionStorage.removeItem(LAST_CLICKED_KEY)
    sessionStorage.removeItem(LAST_CLICKED_INDEX_KEY)
    sessionStorage.removeItem(LAST_VISITED_KEY)
    this.lastClickedItemHref = null
    this.lastClickedItemIndex = null
    this.lastVisitedUrls = null
  }
}

// iOS Safari fix: restore scroll after pressing back (bfcache restore)
/* eslint-disable */
window.addEventListener('pageshow', event => {
  if (event.persisted) new CollectionScrollPosition()
})

document.addEventListener('DOMContentLoaded', () => {
  new CollectionScrollPosition()
})
/* eslint-enable */
